const getters = {
  getAllSubscriptions(state) {
    return state.allSubscriptions;
  },
  getSubscription(state) {
    return state.subscription;
  },
  getSubscriptionTemporal(state) {
    return state.subscriptionTemporal;
  },
  getSubscriptionsOverlay(state) {
    return state.subscriptionsOverlay;
  },
  getMenus(state) {
    return state.menus;
  },
  getMenuOptions(state) {
    return state.menuOptions;
  },
  getPlatesOptions(state) {
    return state.platesOptions;
  },
  getTags(state) {
    return state.tags;
  },
  getIngredients(state) {
    return state.ingredients;
  },
  getIncludeProteins(state) {
    return state.includeProteins;
  },
  getFoodRestrictions(state) {
    return state.foodRestrictions;
  },
  getMenuItems(state) {
    return state.menuItems;
  },
  getCurrentMenu(state) {
    return state.currentMenu;
  },
  getCurrentMenuOption(state) {
    return state.currentMenuOption;
  },
  getCurrentDay(state) {
    return state.currentDay;
  },
  getAllMenuItemProducts(state) {
    return state.allMenuItemProducts;
  }
};

export default getters
